/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiLogout200Schema = z.any();

export const postApiLogoutMutationResponseSchema = z.lazy(
  () => postApiLogout200Schema,
);
